import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { AvatarComponent } from '../avatar/avatar.component';
import { APP_CONFIG } from '../../config/app-config';

@Component({
  selector: 'adf-user-menu',
  standalone: true,
  imports: [CommonModule, NgbDropdownModule, TranslateModule, AvatarComponent],
  templateUrl: './user-menu.component.html',
  styleUrl: './user-menu.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserMenuComponent {
  @Output() logout = new EventEmitter<void>();
  @Input() userDisplayName!: string | null;
  @Input() userEmail!: string | null;

  /** Shown at the foot of the menu so the deployed version is one click away on every screen. */
  readonly appVersion = inject(APP_CONFIG).appVersion;

  /** The Settings item is hidden until user settings are implemented. Flip to true to show it again. */
  readonly showSettings = false;

  onLogout() {
    this.logout.emit();
  }

  onSettings() {
    // Method intentionally left blank: will be implemented in the future when user settings are available
  }
}
